import { portalHomeImages } from "@/components/PortalHome/portalHomeAssets";
import {
  toBonusAwansWidgetData,
  toBonusUhrdWidgetData,
} from "@/data/portal_bonus_campaign_mappers";
import { portalBonusCampaignsApiMock } from "@/data/portal_bonus_campaigns_mock";

export const portalHeroMainImageSrc = portalHomeImages.heroMainImage;

export const portalAccount = {
  balance: portalBonusCampaignsApiMock.account.balance,
  firstStopBalance: 12039,
  updatedAt: portalBonusCampaignsApiMock.account.updatedAt,
  purchases: [
    { icon: "car-side", minimumKey: "portalHome.purchases.carMinimum", count: 20 },
    {
      icon: "truck",
      minimumKey: "portalHome.purchases.busMinimum",
      count: 8,
      countFaded: true,
    },
    { icon: "motorcycle", minimumKey: "portalHome.purchases.bikeMinimum", count: 10 },
  ],
};

export const portalBonusUhid = toBonusUhrdWidgetData(
  portalBonusCampaignsApiMock.programs.uhrd
);
export const portalBonusAwans = toBonusAwansWidgetData(
  portalBonusCampaignsApiMock.programs.awans
);

export const portalFooterLogoSrc = portalHomeImages.footerLogo;

export const portalFooterLinks = [
  { id: "rules", labelKey: "portalHome.footer.links.rules" },
  { id: "contact", labelKey: "portalHome.footer.links.contact" },
  { id: "cookies", labelKey: "portalHome.footer.links.cookies" },
  { id: "terms", labelKey: "portalHome.footer.links.terms" },
  { id: "privacy", labelKey: "portalHome.footer.links.privacy" },
  { id: "faq", labelKey: "portalHome.footer.links.faq" },
  { id: "e8", labelKey: "portalHome.footer.links.e8" },
];

export const portalFooterSocials = [
  { id: "facebook", label: "Facebook", icon: "facebook" },
  { id: "linkedin", label: "LinkedIn", icon: "linkedin" },
  { id: "youtube", label: "YouTube", icon: "youtube" },
];

export const portalBenefits = [
  {
    id: "survey",
    titleKey: "portalHome.benefits.items.survey.title",
    descriptionKey: "portalHome.benefits.items.survey.description",
    brandPrefix: "",
  },
  {
    id: "collection",
    titleKey: "portalHome.benefits.items.collection.title",
    descriptionKey: "portalHome.benefits.items.collection.description",
    brandPrefix: "B",
  },
  {
    id: "drive",
    titleKey: "portalHome.benefits.items.drive.title",
    descriptionKey: "portalHome.benefits.items.drive.description",
    brandPrefix: "B",
  },
  {
    id: "linkup",
    titleKey: "portalHome.benefits.items.linkup.title",
    descriptionKey: "portalHome.benefits.items.linkup.description",
    brandPrefix: "",
  },
];
